:host {
  @apply block;
}

.container {
  @apply flex w-full items-center flex-nowrap;
}

.hex-input {
  @apply grow uppercase;
}

.opacity-input {
  inline-size: 68px;
  margin-inline-start: -1px;
}

:host([scale="s"]) {
  .container {
    @apply flex-wrap gap-y-0.5;
  }

  .opacity-input {
    inline-size: unset;
    margin-inline-start: unset;
  }
}

:host([scale="l"]) {
  .opacity-input {
    inline-size: 88px;
  }
}

@include base-component();
